import React, { useEffect, useState } from "react";
import "./StatBar.scss";
import Counter from "../ui/counter/Counter";
import { Relay } from "../../types/Relay";
import { RelayService } from "../../services/RelayService";

const StatBar: React.FC = () => {
  const [relayData, setRelayData] = useState<Relay | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRelayData = async () => {
      try {
        const data = await RelayService.getRelay();
        setRelayData(data);
      } catch (error) {
        console.error("Failed to load relay data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRelayData(); // Call the function
  }, []);

  return (
    <div className="stat-bar">
      <div className="stat-callout">Rely on Hot Freight</div>
      <div className="stat-items">
        <div className="stat-item">
          <div className="count">
            {loading || !relayData ? (
              "0.0"
            ) : (
              <Counter end={relayData.yearsOfService} suffix="+" />
            )}
          </div>
          <div className="label">Years of Service</div>
        </div>
        <div className="stat-item">
          <div className="count">
            {loading || !relayData ? (
              "0.0"
            ) : (
              <Counter end={relayData.lbsMovedThisYear} suffix="M+" />
            )}
          </div>
          <div className="label">lbs Moved This Year</div>
        </div>
        <div className="stat-item">
          <div className="count">
            {loading || !relayData ? (
              "0.0"
            ) : (
              <Counter end={relayData.warehouseStorageSqFt} suffix="+" />
            )}
          </div>
          <div className="label">sq. ft. Warehouse Storage</div>
        </div>
        <div className="stat-item">
          <div className="count">
            {loading || !relayData ? (
              "0.0"
            ) : (
              <Counter end={relayData.palletsTrackedDaily} suffix="+" />
            )}
          </div>
          <div className="label">Pallets Tracked Daily</div>
        </div>
      </div>
    </div>
  );
};

export default StatBar;